(function() {

    /* globals api, i18n, app, moment, Chart */

    'use strict';

    var defaultUpdateCallback = function(chart, data) {

        if(data.hasOwnProperty('labels')) {

            chart.data.labels = data.labels;
            data = data.data;

        }

        if(data[0] instanceof Array) {

            for(var i=0; i< data.length; i++) {
                chart.data.datasets[i].data = data[i];
            }

        } else {
            chart.data.datasets[0].data = data;
        }

    };

    function updateChart(chart, source, callback) {

        callback = callback || defaultUpdateCallback;

        api.get(source).then(function(response) {

            response.json().then(function(data) {
                callback(chart, data);
                chart.update();
            });

        });

    }

    /* Leads chart */

    var lead = document.getElementById('lead');

    if(lead && lead.classList.contains('chart')) {

        var leadChart = new Chart(lead, {
            type: 'line',
            data: {
                datasets: [{
                    label: i18n.t('chart.lead.label'),
                    backgroundColor: '#FFCE56',
                    data: []
                }]
            },
            options: {
                scales: {
                    xAxes: [{
                        type: 'time',
                        position: 'bottom',
                        time: {
                            tooltipFormat: 'LL',
                            unit: 'day'
                        }
                    }]
                }
            }
        });

        updateChart(leadChart, '/dashboard/leads_added');

        setInterval(function() {
            updateChart(leadChart, '/dashboard/leads_added');
        }, 30000);

    }

    /* Properties chart */

    var property = document.getElementById('property');

    if(property && lead.classList.contains('chart')) {

        var propertyChart = new Chart(property, {
            type: 'line',
            data: {
                datasets: [{
                    label: i18n.t('chart.property.label'),
                    backgroundColor: '#FFCE56',
                    data: []
                }]
            },
            options: {
                scales: {
                    xAxes: [{
                        type: 'time',
                        position: 'bottom',
                        time: {
                            tooltipFormat: 'LL',
                            unit: 'day'
                        }
                    }]
                }
            }
        });

        updateChart(propertyChart, '/dashboard/properties_added');

        setInterval(function() {
            updateChart(propertyChart, '/dashboard/properties_added');
        }, 30000);

    }

    /* Properties ownership chart */

    var ownershipEntityType = document.getElementById('ownership_entity_type');

    if(ownershipEntityType && ownershipEntityType.classList.contains('chart')) {

        var propertyOwnershipEntityTypeChart = new Chart(ownershipEntityType, {
            type: 'doughnut',
            data: {
                labels: [
                    i18n.t('chart.ownership_entity_type.labels.individual'),
                    i18n.t('chart.ownership_entity_type.labels.company'),
                    i18n.t('chart.ownership_entity_type.labels.community_of_heirs')
                ],
                datasets: [{
                    label: i18n.t('chart.ownership_entity_type.label'),
                    backgroundColor: ['#FF6384', '#4BC0C0', '#FFCE56'],
                    data: [0, 0, 0]
                }]
            },
            options: {}
        });

        ownershipEntityType.addEventListener('click', function(e) {

            var chartElement = propertyOwnershipEntityTypeChart.getElementAtEvent(e)[0],
                filter, queryString, index;

            if(chartElement === undefined) {
                return;
            }

            index = chartElement._index;

            if(index !== undefined) {

                filter = {

                    ownership_type: 1,
                    ownership_entity_type: index
                };

                queryString = app.objectToParams(filter, 'filter');

                window.location.href = '/properties?' + queryString;

            }

        }, false);

        updateChart(propertyOwnershipEntityTypeChart, '/dashboard/ownership_entity_types');

    }

    /* Follow-up chart */

    var followUp = document.getElementById('follow_up');

    if(followUp && followUp.classList.contains('chart')) {

        var followUpChart = new Chart(followUp, {
            type: 'bar',
            data: {
                labels: [],
                datasets: [
                    {
                        label: i18n.t('chart.follow_up.labels.follow_up'),
                        backgroundColor: '#FFCE56',
                        data: []
                    }
                ]
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        stacked: true
                    }],
                    xAxes: [{
                        stacked: true
                    }]
                }
            }
        });

        followUp.addEventListener('click', function(e) {

            var chartElement = followUpChart.getElementAtEvent(e)[0],
                year, filter, queryString;

            if(chartElement === undefined) {
                return;
            }

            year = parseInt(chartElement._model.label, 10);

            if(!isNaN(year)) {

                filter = {
                    date: {
                        follow_up_at: {
                            from: moment(year + '-01-01 00:00:00').format(),
                            to: moment(year + '-12-31 23:59:59').format()
                        }
                    }
                };

                queryString = app.objectToParams(filter, 'filter');

                window.location.href = '/follow_ups?' + queryString;

            }

        }, false);

        updateChart(followUpChart, '/dashboard/follow_ups');

    }

    /* Ownership type chart */

    var ownershipType = document.getElementById('ownership_type');

    if(ownershipType && ownershipType.classList.contains('chart')) {

        var ownershipTypeChart = new Chart(ownershipType, {
            type: 'line',
            data: {
                datasets: [
                    {
                        label: i18n.t('chart.ownership_type.labels.partial_ownership'),
                        backgroundColor: '#4BC0C0',
                        data: []
                    },
                    {
                        label: i18n.t('chart.ownership_type.labels.full_ownership'),
                        backgroundColor: '#FF6384',
                        data: []
                    }
                ]
            },
            options: {
                scales: {
                    xAxes: [{
                        type: 'time',
                        position: 'bottom',
                        time: {
                            tooltipFormat: 'LL',
                            unit: 'day'
                        }
                    }]
                }
            }
        });

        updateChart(ownershipTypeChart, '/dashboard/ownership_types', function(chart, data) {

            chart.data.datasets[0].data = data.partial_ownerships;
            chart.data.datasets[1].data = data.full_ownerships;

        });

        /* Ownership type ratio */

        var ownershipTypesRatio = document.getElementById('ownership_types_ratio');

        if(ownershipTypesRatio && ownershipTypesRatio.classList.contains('chart')) {

            var ownershipTypesRatioChart = new Chart(ownershipTypesRatio, {
                type: 'doughnut',
                data: {
                    labels: [
                        i18n.t('chart.ownership_types_ratio.labels.partial_ownership'),
                        i18n.t('chart.ownership_types_ratio.labels.full_ownership')
                    ],
                    datasets: [{
                        label: i18n.t('chart.ownership_types_ratio.title'),
                        backgroundColor: ['#4BC0C0', '#FF6384'],
                        data: [0, 0]
                    }]
                },
                options: {}
            });

            ownershipTypesRatio.addEventListener('click', function(e) {

                var chartElement = ownershipTypesRatioChart.getElementAtEvent(e)[0],
                    filter, queryString, index;

                if(chartElement === undefined) {
                    return;
                }

                index = chartElement._index;

                if(index !== undefined) {

                    filter = {
                        ownership_type: index
                    };

                    queryString = app.objectToParams(filter, 'filter');

                    window.location.href = '/properties?' + queryString;

                }

            }, false);

            updateChart(ownershipTypesRatioChart, '/dashboard/ownership_types_ratio');

        }

        /* Prints */

        var prints = document.getElementById('prints');

        if(prints && prints.classList.contains('chart')) {

            var printsChart = new Chart(prints, {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [{
                        label: i18n.t('chart.prints.label'),
                        backgroundColor: '#FFCE56',
                        data: []
                    }]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            });

            prints.addEventListener('click', function(e) {

                var chartElement = printsChart.getElementAtEvent(e)[0],
                    date, filter, queryString;

                if(chartElement === undefined) {
                    return;
                }

                date = moment(chartElement._model.label, 'DD.MM.YYYY');

                if(date) {

                    filter = {
                        date: {
                            printed_at: {
                                from: date.startOf('day').format(),
                                to: date.endOf('day').format()
                            }
                        }
                    };

                    queryString = app.objectToParams(filter, 'filter');

                    window.location.href = '/mailings?' + queryString;

                }

            }, false);

            updateChart(printsChart, '/dashboard/printed_mailings');

        }

        /* Sales Status chart */
        var salesStatus = document.getElementById('sales_status');

        if(salesStatus && salesStatus.classList.contains('chart')) {

            var salesStatusChart = new Chart(salesStatus, {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: i18n.t('chart.sales_status.labels.for_sale'),
                            backgroundColor: '#4BC0C0',
                            data: []
                        },
                        {
                            label: i18n.t('chart.sales_status.labels.maybe_for_sale'),
                            backgroundColor: '#FFCE56',
                            data: []
                        },
                        {
                            label: i18n.t('chart.sales_status.labels.no_status'),
                            backgroundColor: '#FF6384',
                            data: []
                        }
                    ]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            stacked: true
                        }],
                        xAxes: [{
                            stacked: true
                        }]
                    }
                }
            });

            salesStatus.addEventListener('click', function(e) {

                var chartElement = salesStatusChart.getElementAtEvent(e)[0],
                    year, filter, queryString, index;

                if(chartElement === undefined) {
                    return;
                }

                year = parseInt(chartElement._model.label, 10);

                if(!isNaN(year)) {

                    index = chartElement._datasetIndex;

                    if(index === 2) {
                        index = 'null';
                    }

                    filter = {
                        date: {
                            follow_up_at: {
                                from: moment(year + '-01-01 00:00:00').format(),
                                to: moment(year + '-12-31 23:59:59').format()
                            }
                        },
                        sales_status: index
                    };

                    queryString = app.objectToParams(filter, 'filter');

                    window.location.href = '/follow_ups?' + queryString;

                }

            }, false);

            updateChart(salesStatusChart, '/dashboard/sales_status');

        }



    }

})();